import React, {Component} from 'react'
import {injectIntl, defineMessages} from 'react-intl'
import Select from 'react-select'

const messages = defineMessages({
    "status_draft": {
        id: 'scheduling_page.status_selection.status_draft',
        defaultMessage: 'Draft',
    },
    "status_active": {
        id: 'scheduling_page.status_selection.status_active',
        defaultMessage: 'Active',
    },
    "status_inactive": {
        id: 'scheduling_page.status_selection.status_inactive',
        defaultMessage: 'Inactive',
    },
})

class SchedulingPageStatusSelect extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            options: [],
            selectedOptions: this.props.value || []
        }
        this.state.options = [
            {
                value: 'draft',
                label: this.props.intl.formatMessage(messages["status_draft"])
            },
            {
                value: 'active',
                label: this.props.intl.formatMessage(messages["status_active"])
            },
            {
                value: 'inactive',
                label: this.props.intl.formatMessage(messages["status_inactive"])
            },
        ]

        const defaultCallback = () => {}
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOptions) {
        this.setState({
            selectedOptions: selectedOptions
        }, () => {
            this.onChange(selectedOptions.map(option => option.value), selectedOptions.map(option => option.label))
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOptions) {
            this.setState({
                selectedOptions: nextProps.value || []
            })
        }
    }

    render() {
        return (
            <Select
                name={this.name}
                searchable={false}
                multi
                placeholder={this.placeholder}
                value={this.state.selectedOptions}
                onChange={this.handleChange}
                options={this.state.options}
            />
        )
    }
}

export default injectIntl(SchedulingPageStatusSelect)





// WEBPACK FOOTER //
// ./src/scheduling-page/statusesselection.component.jsx